import { useEffect, useState } from 'react';
import { verifyEmail } from '../../../apiservices/axiosservice/authentication';
import { useLocation } from 'react-router-dom';
import Loading from '../../admincomponents/components/Loading';
import Card from '../../admincomponents/components/Card';
import './styles/VerificationEmail.css';
import BackgroundImageContainer from '../../admincomponents/components/BackgroundImageContainer';
import CustomButton from '../../admincomponents/components/CustomButtom';

const VerificationEmail: React.FC = () => {
  const [message, setMessage] = useState<{ success: boolean; message: string }>(
    { success: false, message: '' }
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();

  const handleEmailVerification = async () => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    if (token) {
      try {
        setIsLoading(true);
        const response = await verifyEmail(token);

        if (response.data) {
          setMessage({ success: true, message: response.message });
        }
        setIsLoading(false);
      } catch (error) {
        setMessage({ success: false, message: error.message });
        setIsLoading(false);
      }
    } else {
      setMessage({ success: false, message: 'Token not found' });
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loading message="Verifying email..." />;
  }
  return (
    <div className="verification-container">
      <div className="verification-card">
        <div className="icon-wrapper">
          {message.success && message.message ? (
            <svg className="success-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M8 12.5L10.5 15L16 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          ) : (
            <svg className="email-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
        <h1 className="verification-title">
          {message.success && message.message ? 'Email Verified!' : 'Verify Your Email'}
        </h1>
        {!message.message && (
          <p className="verification-description">
            Click the button below to verify your email address and activate your account.
          </p>
        )}
        {!message.message && (
          <CustomButton
            className="verify-button"
            onClick={handleEmailVerification}
          >
            Verify Email
          </CustomButton>
        )}
        {message.message && (
          <div className={`verify-message ${message.success ? 'success' : 'error'}`}>
            {message.message}
          </div>
        )}
        {message.success && message.message && (
          <a href="/login" className="login-link">Return to Login</a>
        )}
      </div>
    </div>
  );
};

export default VerificationEmail;
